"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginMagicForm = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../atoms");

var _molecules = require("../../molecules");

var _Shared = require("../Shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// eslint-disable-next-line no-empty-character-class
var EmailRegex = /([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+))/gi;

var LoginMagicForm = function LoginMagicForm(_ref) {
  var width = _ref.width,
      center = _ref.center,
      generalError = _ref.generalError,
      setGeneralError = _ref.setGeneralError,
      setStep = _ref.setStep,
      email = _ref.email,
      setEmail = _ref.setEmail,
      emailError = _ref.emailError,
      setEmailError = _ref.setEmailError,
      redirectURL = _ref.redirectURL,
      children = _ref.children;

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(emailError !== '')) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              if (!(email.length <= 0)) {
                _context.next = 5;
                break;
              }

              setEmailError('Email is required');
              return _context.abrupt("return");

            case 5:
              setGeneralError('');
              _context.next = 8;
              return sendMagicEmail(email);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var sendMagicEmail = function sendMagicEmail(email) {
    return new Promise(function (resolve, reject) {
      setGeneralError(null); // send magic email

      var path = window.location.href.split('?');
      var queryParams = '';

      if (path[1]) {
        queryParams = "?" + path[1];
      }

      var proceedURL = path[0] + '/userid/${userId}/token/${token}' + queryParams;
      var params = {
        email: email,
        email_type: 'magic-code',
        // eslint-disable-next-line no-template-curly-in-string
        proceed_url: proceedURL
      };
      (0, _Shared.post)("".concat(process.env.REACT_APP_WEB_API, "/webapp/autologin-url/send"), params, {
        contentType: 'form',
        cors: true,
        credentials: true
      }).then(function (json) {
        console.log('autologin', json);
        setStep('enter-code');
        resolve(true);
      }).catch(function (err) {
        console.log('sendMagic error', err);
        setGeneralError('Email not found');
        resolve(false);
      });
    });
  };

  var styles = {};

  if (width) {
    styles.maxWidth = width;
  }

  if (center) {
    styles.margin = '0 auto';
  }

  return /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    style: styles,
    className: "LoginForm"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    center: true,
    spacingBottom: "4"
  }, /*#__PURE__*/_react.default.createElement(_molecules.Input, {
    name: "email",
    type: _molecules.Input.Type.Email,
    placeholder: "Trace email",
    value: email,
    error: generalError ? generalError : emailError,
    onChange: function onChange(val) {
      return setEmail(val);
    },
    onBlur: function onBlur(e) {
      if (email.length > 0 && email.length < 3) {
        setEmailError('Email is required');
        return;
      }

      if (email.length < 3) {
        setEmailError('');
        return;
      }

      EmailRegex.lastIndex = 0;

      if (!EmailRegex.test(email)) {
        setEmailError('Must be a valid email address');
        return;
      }

      if (emailError !== '') {
        setEmailError('');
      }
    }
  })), /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    trkAction: "Email Sign In Pressed",
    content: "Email sign in code",
    primary: true,
    onClick: onSubmit,
    spacingTop: "4"
  }), children);
};

exports.LoginMagicForm = LoginMagicForm;